// extracted by mini-css-extract-plugin
export default {"main":"Intro_main__YpIYh","bounce":"Intro_bounce__GafFT","homeBubble1":"Intro_homeBubble1__1e9fT","homeBubble2":"Intro_homeBubble2__uUc+s","homeBubble3":"Intro_homeBubble3__i91yY"};